import { render, staticRenderFns } from "./Channels.vue?vue&type=template&id=30284e0a"
import script from "./Channels.vue?vue&type=script&lang=js"
export * from "./Channels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/print-suite/source/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30284e0a')) {
      api.createRecord('30284e0a', component.options)
    } else {
      api.reload('30284e0a', component.options)
    }
    module.hot.accept("./Channels.vue?vue&type=template&id=30284e0a", function () {
      api.rerender('30284e0a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Channels.vue"
export default component.exports